import emitter from 'scripts/utils/emitter'

export function showSpinner () {
  emitter.emit('spinner:show')
}

export function hideSpinner () {
  emitter.emit('spinner:hide')
}
